import { render, staticRenderFns } from "./admin-business-list.vue?vue&type=template&id=08ca5d2a&"
import script from "./admin-business-list.vue?vue&type=script&lang=js&"
export * from "./admin-business-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports